/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useRef } from 'react';
import AnimalType from '../../../../../enums/animal-type';
import { useHistory, useParams } from 'react-router-dom';
import { useService } from '../../../../../services/services';
import { route } from '../../../../../services/utils';
import { LIVESTOCK_ANIMALS_PREGNANCY_CHECK_VIEW } from '../../../../../router/routes';
import { FormMode } from '../../../../../enums/form-mode';
import { SubmitType } from '../../../../../components/form';
import { AnimalEventAnimal } from '../../../../../interfaces/animal-event';
import { useDispatch } from 'react-redux';
import { addNotice } from '../../../../../store/global-slice';
import { useTranslation } from 'react-i18next';
import { of } from 'rxjs';

export function usePregnancyStore(animals: AnimalEventAnimal[]) {
  const { farmId } = useParams<{
    farmId: string;
  }>();
  const history = useHistory();
  const { animalEventService } = useService();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const transformAnimal = () =>
    animals.map((animal: AnimalEventAnimal) => ({ id: animal.id }));
  const allAnimlas = useRef(transformAnimal());

  useEffect(() => {
    allAnimlas.current = transformAnimal();
  }, [animals]);

  return useCallback<SubmitType<any>>((data) => {
    if (allAnimlas.current.length === 0) {
      dispatch(
        addNotice({
          accessor: 'CreateForm',
          status: 'error',
          description: t(
            'pages.livestock.animals_and_events.animals.no_animal'
          ),
        })
      );
      return [of(null)];
    } else {
      const formData = {
        type: AnimalType.pregnancy,
        status: data.status,
        animals: allAnimlas.current,
        status_pregnant: data,
        investigation_method_id: data.investigation_method.value,
        extra_data: {
          status_pregnant: data.status_pregnant,
          number_of_fetuses: data.number_of_fetuses,
        },
        date: data.date,
        notes: data.notes,
        file_id: data.file[0]?.id,
        purpose_and_place_of_use: null,
      };

      return [
        animalEventService.store(farmId, formData),
        (response) => {
          history.push(
            route(LIVESTOCK_ANIMALS_PREGNANCY_CHECK_VIEW, {
              farmId,
              id: response.id,
              mode: FormMode.view,
            })
          );
        },
      ];
    }
  }, []);
}
